(() => {
  const setMenuState = (widget, menuSelector, triggerSelector, open) => {
    const menu = widget?.querySelector(menuSelector);
    const trigger = widget?.querySelector(triggerSelector);
    if (!menu) return;
    menu.hidden = !open;
    trigger?.setAttribute('aria-expanded', open ? 'true' : 'false');
  };

  const closeUtilityMenus = (root, except = null) => {
    root.querySelectorAll('[data-delia-tasting-calendar]').forEach((widget) => {
      if (widget !== except) setMenuState(widget, '[data-calendar-menu]', '[data-calendar-trigger]', false);
    });
    root.querySelectorAll('[data-delia-tasting-share]').forEach((widget) => {
      if (widget !== except) setMenuState(widget, '[data-share-menu]', '[data-share-trigger]', false);
    });
  };

  const formatCalendarUtc = (date) => date
    .toISOString()
    .replace(/[-:]/g, '')
    .replace(/\.\d{3}Z$/, 'Z');

  const escapeIcsText = (value) => String(value || '')
    .replace(/\\/g, '\\\\')
    .replace(/\r?\n/g, '\\n')
    .replace(/,/g, '\\,')
    .replace(/;/g, '\\;');

  const initializeCalendar = (root, calendar) => {
    if (calendar.dataset.deliaCalendarReady === 'true') return;
    calendar.dataset.deliaCalendarReady = 'true';

    const start = new Date(calendar.dataset.calendarStart || '');
    const end = new Date(calendar.dataset.calendarEnd || '');
    const trigger = calendar.querySelector('[data-calendar-trigger]');
    const google = calendar.querySelector('[data-calendar-google]');
    const outlook = calendar.querySelector('[data-calendar-outlook]');
    const download = calendar.querySelector('[data-calendar-ics]');
    const status = calendar.querySelector('[data-calendar-status]');
    if (!trigger || Number.isNaN(start.getTime()) || Number.isNaN(end.getTime()) || end <= start) {
      calendar.hidden = true;
      return;
    }

    const title = calendar.dataset.calendarTitle || document.title;
    const url = calendar.dataset.calendarUrl || window.location.href;
    const location = calendar.dataset.calendarLocation || '';
    const description = calendar.dataset.calendarDescription || '';
    const details = [description, url].filter(Boolean).join('\n\n');
    const googleParams = new URLSearchParams({
      action: 'TEMPLATE',
      text: title,
      dates: `${formatCalendarUtc(start)}/${formatCalendarUtc(end)}`,
      details,
      location
    });
    const outlookParams = new URLSearchParams({
      path: '/calendar/action/compose',
      rru: 'addevent',
      subject: title,
      startdt: start.toISOString(),
      enddt: end.toISOString(),
      body: details,
      location
    });
    if (google) google.href = `https://calendar.google.com/calendar/render?${googleParams}`;
    if (outlook) outlook.href = `https://outlook.live.com/calendar/0/deeplink/compose?${outlookParams}`;

    trigger.addEventListener('click', () => {
      const menu = calendar.querySelector('[data-calendar-menu]');
      const shouldOpen = Boolean(menu?.hidden);
      closeUtilityMenus(root, calendar);
      setMenuState(calendar, '[data-calendar-menu]', '[data-calendar-trigger]', shouldOpen);
    });

    download?.addEventListener('click', () => {
      const calendarLines = [
        'BEGIN:VCALENDAR',
        'VERSION:2.0',
        'PRODID:-//Delias Whiskyshop//Tasting//DE',
        'CALSCALE:GREGORIAN',
        'METHOD:PUBLISH',
        'BEGIN:VEVENT',
        `UID:${escapeIcsText(calendar.dataset.calendarUid || `${start.getTime()}@deliawhisky.de`)}`,
        `DTSTAMP:${formatCalendarUtc(new Date())}`,
        `DTSTART:${formatCalendarUtc(start)}`,
        `DTEND:${formatCalendarUtc(end)}`,
        `SUMMARY:${escapeIcsText(title)}`,
        `DESCRIPTION:${escapeIcsText(details)}`,
        `LOCATION:${escapeIcsText(location)}`,
        `URL:${escapeIcsText(url)}`,
        'END:VEVENT',
        'END:VCALENDAR'
      ];
      const blob = new Blob([calendarLines.join('\r\n')], { type: 'text/calendar;charset=utf-8' });
      const objectUrl = URL.createObjectURL(blob);
      const anchor = document.createElement('a');
      anchor.href = objectUrl;
      anchor.download = `delia-tasting-${start.toISOString().slice(0, 10)}.ics`;
      document.body.append(anchor);
      anchor.click();
      anchor.remove();
      window.setTimeout(() => URL.revokeObjectURL(objectUrl), 0);
      if (status) status.textContent = calendar.dataset.calendarDownloaded || '';
      setMenuState(calendar, '[data-calendar-menu]', '[data-calendar-trigger]', false);
      window.setTimeout(() => { if (status) status.textContent = ''; }, 2400);
    });
  };

  const copyText = async (value) => {
    try {
      await navigator.clipboard.writeText(value);
    } catch (_) {
      const input = document.createElement('textarea');
      input.value = value;
      input.setAttribute('readonly', '');
      input.style.position = 'fixed';
      input.style.opacity = '0';
      document.body.append(input);
      input.select();
      document.execCommand('copy');
      input.remove();
    }
  };

  const initializeShare = (root, share) => {
    if (share.dataset.deliaShareReady === 'true') return;
    share.dataset.deliaShareReady = 'true';
    const trigger = share.querySelector('[data-share-trigger]');
    const copy = share.querySelector('[data-share-copy]');
    const status = share.querySelector('[data-share-status]');
    const shareData = {
      title: share.dataset.shareTitle || document.title,
      url: share.dataset.shareUrl || window.location.href
    };

    trigger?.addEventListener('click', async () => {
      if (typeof navigator.share === 'function') {
        try {
          await navigator.share(shareData);
          return;
        } catch (error) {
          if (error?.name === 'AbortError') return;
        }
      }
      const menu = share.querySelector('[data-share-menu]');
      const shouldOpen = Boolean(menu?.hidden);
      closeUtilityMenus(root, share);
      setMenuState(share, '[data-share-menu]', '[data-share-trigger]', shouldOpen);
    });

    copy?.addEventListener('click', async () => {
      await copyText(shareData.url);
      if (status) status.textContent = share.dataset.shareCopied || '';
      setMenuState(share, '[data-share-menu]', '[data-share-trigger]', false);
      window.setTimeout(() => { if (status) status.textContent = ''; }, 2400);
    });
  };

  const initializeTabs = (root) => {
    root.querySelectorAll('[data-delia-tasting-tabs]').forEach((tabsRoot) => {
      if (tabsRoot.dataset.deliaTabsReady === 'true') return;
      tabsRoot.dataset.deliaTabsReady = 'true';

      const buttons = [...tabsRoot.querySelectorAll('[data-delia-tasting-tab]')];
      const panels = [...tabsRoot.querySelectorAll('[data-delia-tasting-panel]')];
      const closeAll = () => {
        buttons.forEach((button) => button.setAttribute('aria-expanded', 'false'));
        panels.forEach((panel) => { panel.hidden = true; });
      };

      buttons.forEach((button, index) => {
        button.addEventListener('click', () => {
          const shouldOpen = button.getAttribute('aria-expanded') !== 'true';
          closeAll();
          if (!shouldOpen) return;
          button.setAttribute('aria-expanded', 'true');
          const panel = tabsRoot.querySelector(`[data-delia-tasting-panel="${button.dataset.deliaTastingTab}"]`);
          if (panel) panel.hidden = false;
        });

        button.addEventListener('keydown', (event) => {
          let nextIndex = null;
          if (event.key === 'ArrowRight') nextIndex = (index + 1) % buttons.length;
          if (event.key === 'ArrowLeft') nextIndex = (index - 1 + buttons.length) % buttons.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = buttons.length - 1;
          if (nextIndex === null) return;
          event.preventDefault();
          buttons[nextIndex].focus();
        });
      });

      closeAll();
    });
  };

  const initializeProduct = (root) => {
    initializeTabs(root);
    root.querySelectorAll('[data-delia-tasting-calendar]').forEach((calendar) => initializeCalendar(root, calendar));
    root.querySelectorAll('[data-delia-tasting-share]').forEach((share) => initializeShare(root, share));
    if (root.dataset.deliaUtilitiesReady === 'true') return;
    root.dataset.deliaUtilitiesReady = 'true';
    root.addEventListener('click', (event) => {
      const utility = event.target.closest('.delia-tasting-product__utility');
      if (!utility) closeUtilityMenus(root);
    });
    root.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeUtilityMenus(root);
    });
  };

  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-delia-tasting-product-concept]').forEach(initializeProduct);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize());
  } else {
    initialize();
  }
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
